import { map } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';
import { CustomerSelectorPluginService } from './customerselector-plugin.service';

@Pipe({
    name: 'languages',
    standalone: false
})
export class LanguagesPipe implements PipeTransform {
  public languages: any;
  constructor(private service: CustomerSelectorPluginService) {
    this.languages = this.service.getLanguages();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.languages);
  }
}

@Pipe({
    name: 'country',
    standalone: false
})
export class CountryPipe implements PipeTransform {
  constructor(private service: CustomerSelectorPluginService) {}

  transform(code: string): any {
    return this.service.getCountry(code).pipe(
      map((data: any) => {
        if (data) {
          return data.label;
        } else {
          return '';
        }
      })
    );
  }
}
